import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch } from 'react-redux'
import { updateOrderInfo } from '../../../actions/editOrderActions';
import { Dialog, DialogTitle, DialogContent, DialogActions, Tooltip, Button } from '@material-ui/core';
import { ValidatorForm, TextValidator} from 'react-material-ui-form-validator';
import CloseIcon from '@material-ui/icons/Close';
import Alert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import { useTranslation } from 'react-i18next';
import { showAlertSnackbar } from '../../../reducers/uiSlice';

const useStyles = makeStyles((theme)=> ({
      root: {
        zIndex: theme.zIndex.modal - 1
      },      
}))

export default function TransshipmentOperation(props) {
    const { handleTransClose, orderId, transOpen, onTransitionUpdate } = props;    
    const classes = useStyles();
    const {t} = useTranslation('editOrder');    
    const dispatch = useDispatch();

    //used for transshipment
    const [transshipmentNo, setTransshipmentNo] = useState();    
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [open, setOpen] = useState(false);
    
    useEffect(() => {
        setOpen(transOpen);
        if(transOpen) {
            setIsSubmitted(true);
        }
    }, [transOpen])
    useEffect(() => {
        if(transshipmentNo) {
            setIsSubmitted(false);
        } else {
            setIsSubmitted(true);
        }
    }, [transshipmentNo])

    return (
        <Dialog className={classes.root}
            onClose={() => handleTransClose(false)} 
            open={open}
        >
            <DialogTitle>
                {t('dialog_transshipment_title')} 
                <Tooltip title={t('common:cancel')} aria-label="cancel" style={{float: "right"}}>
                    <CloseIcon onClick={() => handleTransClose(false)}></CloseIcon>
                </Tooltip>        
            </DialogTitle>            
            <DialogContent dividers ></DialogContent>            
            <ValidatorForm onSubmit={handleSubmit}>
                <TextValidator
                    autoFocus
                    label={t('transshipment_no')}
                    type="string"
                    InputLabelProps={{ shrink: true }}
                    variant="outlined"
                    fullWidth
                    value={transshipmentNo}
                    onChange={(e)=> setTransshipmentNo(e.target.value)}                 
                    style={{
                        width: 300, 
                        paddingBottom: 16
                    }}
                />
            </ValidatorForm>
            <DialogActions >
                <Button 
                    onClick={()=>handleTransClose(false)}
                >
                    {t('common:cancel')}
                </Button>
                <Button 
                    type="submit" 
                    color='primary' 
                    disabled={isSubmitted} 
                    onClick={handleSubmit} 
                >
                    {t('common:submit')}
                </Button>           
            </DialogActions>                
        </Dialog> 
    )

    /**
    * submit the secondary express request
    */
    function handleSubmit() {
        let params = {};
        params.shipper = transshipmentNo;
        setIsSubmitted(true);
        dispatch(updateOrderInfo(orderId, params))
        .then(()=>{
            setIsSubmitted(false);
            dispatch(showAlertSnackbar({message: t('trans_success_message'), type: 'success'}))
            onTransitionUpdate();
            handleTransClose(false);
        })
        .catch(() => {
            setIsSubmitted(false);
            dispatch(showAlertSnackbar({message: t('trans_fail_message'), type: 'error'}))
        })
    }    

}
